var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNextdoor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8BC94D",
  d: "M2.5 3.75a.75.75 0 0 0-.75.75v3A4.25 4.25 0 0 0 6 11.75h.75v7.75c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-8a2.25 2.25 0 0 1 4.5 0v8c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-8A7.75 7.75 0 0 0 8.018 7.25H8a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 0-.75-.75z"
})));
export default SvgNextdoor;